import { useParams } from 'react-router-dom';
import { TermDetailView } from '@/views/TermDetailView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const TermDetailPage = () => {
  const { courseId, intakeId, groupNumber, termId } = useParams<{
    courseId: string;
    intakeId: string;
    groupNumber: string;
    termId: string;
  }>();

  if (!courseId || !intakeId || !groupNumber || !termId) {
    return null;
  }

  return (
    <MainLayout headerTitle="Term Detail">
      <TermDetailView
        courseId={Number(courseId)}
        intakeId={Number(intakeId)}
        groupNumber={Number(groupNumber)}
        termId={Number(termId)}
      />
    </MainLayout>
  );
};

export default TermDetailPage;

